module.exports = __webpack_public_path__ + "static/media/plus.355da7a5.svg";